import { IconType } from 'components/atoms/Icon';
import { TBarChartValue } from 'components/atoms/SimpleBarChart/SimpleBarChart';
import Container from 'components/molecules/Container/Container';
import { HeadingWithIcon } from 'components/molecules/HeadingWithIcon';
import NavbarWithBackLink from 'components/molecules/NavbarWithBackLink/NavbarWithBackLink';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TSkillWithAnswer } from '../types';
import Assessment from './Assessment';

interface IRoleSpecificSoftSkillsAssessmentMobile {
  headingTitle: string;
  headingIcon: IconType;
  headingDescription: string;
  loading: boolean;
  initialSkillsWithAnswers: TSkillWithAnswer[];
  gradeBands: {
    proficiency: TBarChartValue;
  }[];
  skillName: string;
  onSubmit: (skillsWithAnswers: TSkillWithAnswer[]) => void;
  hasMarkAllButton?: boolean;
  /** Back-link target — supplied by the hosting flow's navigation seam. */
  backUrl: string;
}

const RoleSpecificSoftSkillsAssessmentMobile: FC<
  IRoleSpecificSoftSkillsAssessmentMobile
> = ({
  headingDescription,
  headingIcon,
  headingTitle,
  initialSkillsWithAnswers,
  gradeBands,
  loading,
  hasMarkAllButton,
  skillName,
  onSubmit,
  backUrl,
}) => {
  const { t } = useTranslation();
  return (
    <Container className="role-specific-soft-skills-assessment-mobile">
      <NavbarWithBackLink
        to={backUrl}
        ariaLabel={t('assessment.returnToAllAssessmentActions')}
        label={t('assessment.actions')}
      />
      <HeadingWithIcon
        title={headingTitle}
        icon={headingIcon}
        description={headingDescription}
        alt=""
      />
      <Assessment
        initialSkillsWithAnswers={initialSkillsWithAnswers}
        gradeBands={gradeBands}
        loading={loading}
        skillName={skillName}
        onSubmit={onSubmit}
        hasMarkAllButton={hasMarkAllButton}
      />
    </Container>
  );
};
export default RoleSpecificSoftSkillsAssessmentMobile;
